import { filter, takeUntil } from 'rxjs/operators';
import { Component, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { TranslationKeysUtil } from '~shared/utils/translation-keys.util';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-page-title',
  template: '{{ pageTitleTranslationKey | translate }}',
})
export class PageTitleComponent implements OnDestroy {
  public pageTitleTranslationKey: string;
  private destroy$ = new Subject<void>();

  constructor(
    private router: Router,
  ) {
    this.updatePageTitleTranslationKey();

    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe(this.updatePageTitleTranslationKey.bind(this));
  }

  private updatePageTitleTranslationKey(): void {
    const pageUrl = this.router.url.split('?')[0];
    this.pageTitleTranslationKey = TranslationKeysUtil.getPageTitle(pageUrl);
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
